// Field Names from Firestore:  Clue object
export const TEXT = 'clue_text';
export const DURATION_MIN = 'duration_min';
export const CODE = 'code';
export const CLUE_LATLON = 'latlon';         // type google lat lon

export const ANSWER_PHOTO = 'answer_photo';
export const ANSWER_THUMB = 'answer_thumb';
export const THUMB = 'clue_thumb';



// WEBPACK FOOTER //
// ./src/constants/Clue.js